module.exports = __webpack_public_path__ + "static/img/会计引擎3.2d02769c.png";